<div>
  <div mat-dialog-title class="dialog-title-row"><span class="header-font">{{data.header}}</span>
  <span>
    <mat-icon id="close-icon" class="pointer" (click)="closeDialog()">close</mat-icon>
  </span>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  @if ((data.data.specimenRequirement != '' && data.data.specimenRequirement != null) || data.data.specimenContainerCount != null) {
    <div class="specimen-details-container">
      <div class="specimen-container" fxLayout="row" fxLayoutAlign="flex-start" fxLayout.xs="column" fxLayout.sm="column">
        <p class="spec-field-name font-bold">Specimen Type -&nbsp;</p>
        <p class="value-container">{{data.data.specimenSampleType}}</p>
      </div>
      <div class="specimen-container" fxLayout="row" fxLayoutAlign="flex-start" fxLayout.xs="column" fxLayout.sm="column">
        <p class="spec-field-name font-bold">Container Count -&nbsp;</p>
        <p class="value-container">{{data.data.specimenContainerCount}}</p>
      </div>
      <div class="specimen-container" fxLayout="row" fxLayoutAlign="flex-start" fxLayout.xs="column" fxLayout.sm="column">
        <p class="req-field-name font-bold"> Requirement -&nbsp;</p>
        <div class="value-container" [innerHTML]="data.data.specimenRequirement"></div></div>
      </div>
    }
  </div>
</div>